import React from "react";
import { useIntl } from "react-intl";
import type { Language } from "src/shared/objects/Language";

export interface ILanguageProps {
  children: Language;
}

export const LanguageName = ({ children }: ILanguageProps) => {
  const intl = useIntl();
  const languageString: string = children.languageName[intl.locale];
  return <>{languageString}</>;
};
